import React from 'react';

import Skeleton from '@components/Skeleton';

import styles from './Skeleton.module.scss';

const TravellerSkeleton = () => {
  return (
    <div>
      {/* Main traveller */}
      <Skeleton width={110} height={24} />
      <div className={styles.marginBottom}></div>
      <Skeleton width={'100%'} height={92} />
      <div className={styles.divider}></div>

      {/* Other travellers */}
      <Skeleton width={110} height={24} />
      <div className={styles.marginBottom}></div>
      <Skeleton width={'100%'} height={92} />
      <div className={styles.marginBottom}></div>
      {/* Add New Button */}
      <Skeleton width={'100%'} height={50} />
    </div>
  );
};

export default TravellerSkeleton;
